var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 24,
  fill: "none",
  viewBox: "0 0 16 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m8.585 7.758 2.599-5.201a.91.91 0 0 1 .815-.501.92.92 0 0 1 .815.5l2.599 5.202 5.809.839a.9.9 0 0 1 .733.61.89.89 0 0 1-.23.923l-4.203 4.046.992 5.717c.127.733-.653 1.292-1.32.946l-5.195-2.7-5.196 2.7c-.666.347-1.446-.213-1.32-.947l.993-5.717-4.203-4.046a.895.895 0 0 1 .503-1.531z"
})));
export default SvgStar;